<section
  class="section"
  *ngIf="newsList"
  [ngClass]="{ 'white-100': isWhiteBg }"
>
  <div class="section-container-full" [ngClass]="{ ' mar-b-a': isWhiteBg }">
    <h2 class="section-heading">
      <span>{{ newsList?.title }}</span>
    </h2>
    <div class="section-latest-news-wrapper">
      <div class="section-latest-news">
        <ng-container *ngFor="let item of newsList.blogElements; let i = index">
          <ng-container
            *ngIf="item?.fields?.tags?.fields?.tagName == 'Product'"
          >
            <!------------ News-1 ------------>
            <div class="latest-news-container">
              <figure class="position-relative latest-news-image">
                <div class="cs_ratio mb-xl-4 mb-3">
                  <img
                    loading="lazy"
                    style="border-radius: 24px"
                    [src]="item?.fields?.blogImage?.fields?.file?.url"
                    [alt]="item?.fields?.blogImage?.fields?.title"
                  />
                </div>
                <a
                  href="{{
                    '../../About-Us/Resources/Blog/Article/' +
                      item.fields?.blogId | urlParams:queryParams
                  }}"
                  class="stretched-link"
                ></a>
              </figure>
              <div class="latest-news-content">
                <div class="badge">
                  {{ item?.fields?.tags?.fields?.tagName }}
                </div>
                <h5 class="latest-news-heading">
                  {{ item.fields?.title }}
                </h5>
              </div>
              <a
                href="{{
                  '../../About-Us/Resources/Blog/Article/' + item.fields?.blogId | urlParams:queryParams
                }}"
                class="stretched-link"
              ></a>
            </div>
          </ng-container>
        </ng-container>
        <div class="latest-news-container"></div>
      </div>
    </div>
  </div>
</section>
